import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { InfiniteScrollTableState } from '../state';
import { UseCollectionComponentBaseParams } from './useCollectionComponentBaseParams';

export interface UseTableParams<T, F extends FiltersMap = OptionalFiltersMap>
  extends UseCollectionComponentBaseParams<T, F> {}

export function useTable<T, F extends FiltersMap = OptionalFiltersMap>({
  collection,
}: UseTableParams<T, F>) {
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new InfiniteScrollTableState({
        collection,
        container,
      }),
  );

  return state;
}
